module.exports = __webpack_public_path__ + "img/bg_function01_2_t.abb64137.gif";